import React from "react";
import { PlanCard } from "./PlanCard";

export const PlansGrid = ({
  plans,
  selectedPlan,
  onSelectPlan,
  onContinue,
  gstRate = 0.18,
  hasActivePlan = false,
  activePlanId = null,
}) => (
  <div
    className={`grid gap-4 w-full ${
      plans.length === 1
        ? "grid-cols-1 max-w-lg mx-auto"
        : "grid-cols-1 lg:grid-cols-2"
    }`}
  >
    {plans.map((plan) => (
      <PlanCard
        key={plan.id}
        plan={plan}
        selectedPlan={selectedPlan}
        onSelectPlan={onSelectPlan}
        onContinue={onContinue}
        gstRate={gstRate}
        hasActivePlan={hasActivePlan}
        activePlanId={activePlanId}
      />
    ))}
  </div>
);
